import React, { Component } from 'react'
import { Context } from '../Context'
import logo from '../../assets/rhomberg-logo.svg'
import Mouse from '../../assets/mouse.png'
import AnimatedLogo from '../Libs/AnimatedLogo'
import AnimatedBackgroundImage from '../Libs/AnimatedBackgroundImage'
import AnimatedMenu from '../Libs/AnimatedMenu'

let items = [
    {
        id: 1,
        title: 'Leistungen',
        description: 'Leistungen ......',
    },
    {
        id: 2,
        title: 'Gewerbe-\nkunden',
        description: 'Gewerbekunden ......',
    },
    {
        id: 3,
        title: 'Privatkunden',
        description: 'Privatkunden ......',
    },
    {
        id: 4,
        title: 'Wohnanlagen',
        description: 'Wohnanlagen ......',
    },
]

export default class Home extends Component {
    static contextType = Context

    constructor(props) {
        super(props)

        this.state = {
            selectedItem: items[0],
        }
    }

    render() {
        return (
            <div className="main background-white">
                <AnimatedLogo image={logo} />
                <div className="row h-100">
                    <div className="col-12 col-md-3 h-100">
                        <div className="row h-100 justify-content-center">
                            <div className="col-md-10 align-self-center">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>{this.state.selectedItem.description}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-8 h-100">
                        <div className="row h-100 justify-content-center">
                            <div className="col-md-10 align-self-center">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <AnimatedMenu
                                            items={items}
                                            style={{ transform: 'scale(1.5)', zIndex: 10 }}
                                            itemClick={item => {
                                                this.setState({
                                                    selectedItem: item,
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1 d-sm-none d-md-block h-100">
                        <AnimatedBackgroundImage class="animated-background-image" imageStyle={{ marginTop: '40%' }} image={Mouse} maxMoveX={400} maxMoveY={400} />
                    </div>
                </div>
            </div>
        )
    }
}
